








import { defineComponent } from 'vue-demi';
import { FitButton } from '@tencent/wphk-ui';
import { i18n } from '../../../../i18n';

export default defineComponent({
  name: 'MallContentListFail',
  components: {
    FitButton,
  },
  emits: ['retry'],
  setup(props, context) {
    function handleClick() {
      context.emit('retry');
    }

    return {
      i18n,
      handleClick,
    };
  },
});
